<template>
	<div class="experiment-page">
		<!-- 顶部标题栏 —— 已固定 ✅ -->
		
			<div v-if="!isMoonTomato&&!isTomatoSimulator" style="height: 100%;">
				<div class="header-bar">
					<span class="title-icon">🍅</span>
					<span class="title-text">番茄生长实验室</span>
				</div>

				<!-- 可滚动内容 -->
				<div class="scroll-content" style="overflow-y: auto;">
					<!-- 称号进度卡片 -->
					<div class="rank-card">
						<div class="rank-icon">🔬</div>
						<div class="rank-info">
							<h2 class="rank-title">小小探索者</h2>
							<p class="rank-desc">再完成 2 次测试可获得「植物观察员」称号</p>
						</div>
					</div>

					<!-- 实验数据统计 -->
					<div class="stats-row">
						<div class="stat-item">
							<div class="stat-num">0</div>
							<div class="stat-label">实验次数</div>
						</div>
						<div class="stat-item">
							<div class="stat-num">0</div>
							<div class="stat-label">成功次数</div>
						</div>
					</div>

					<!-- 实验模式标题 -->
					<h3 class="mode-title">选择实验模式</h3>

					<!-- 地球模式 -->
					<div class="mode-card" @click="isTomatoSimulator=true">
						<div class="mode-header">
							<span class="mode-icon">🌍</span>
							<h4 class="mode-name">地球模式</h4>
						</div>
						<p class="mode-desc">
							探索地球环境下番茄生长所需的条件：空气、水分、温度、光照、土壤
						</p>
						<div class="tag-group">
							<span class="tag-item">🌱 发芽</span>
							<span class="tag-item">🌿 生长</span>
							<span class="tag-item">🍅 结果</span>
						</div>
					</div>

					<!-- 月球模式 -->
					<div class="mode-card" @click="isMoonTomato=true">
						<div class="mode-header">
							<span class="mode-icon">🌙</span>
							<h4 class="mode-name">月球模式</h4>
						</div>
						<p class="mode-desc">
							挑战月球特殊环境：电力系统、生命维持设备、防歪支架
						</p>
						<div class="tag-group">
							<span class="tag-item">⚡ 电力</span>
							<span class="tag-item">💨 空气</span>
							<span class="tag-item">🧬 变异</span>
						</div>
					</div>

					<!-- 探索提示 -->
					<div class="tip-card">
						<div class="tip-header">
							<span class="tip-icon">💡</span>
							<h4 class="tip-title">探索提示</h4>
						</div>
						<ul class="tip-list">
							<li>动手调整开关，观察番茄生长状态</li>
							<li>条件都对了也可能遭遇灾害哦～</li>
							<li>月球模式需要先开启电力系统</li>
						</ul>
					</div>
				</div>
			</div>
			<MoonTomato v-if="isMoonTomato" style="z-index: 3000;position:fixed;top:0;left:0;width:100%;height:100%;overflow:auto;background:#fff;"  @toBack="isMoonTomato=false" />
			<TomatoSimulator 
			  v-if="isTomatoSimulator" 
			  style="z-index: 3000;position:fixed;top:0;left:0;width:100%;height:100%;overflow:auto;background:#fff;" 
			  @toBack="isTomatoSimulator=false" 
			/>
		</div>
</template>

<script>
	import MoonTomato from './MoonTomato.vue'
	import TomatoSimulator from './TomatoSimulator.vue'
	export default {
		name: "ExperimentPage",
		components: {
			MoonTomato, // 注册组件
			TomatoSimulator

		},
		props: {
			courseClassId: {
				type: String,
				default: "0"
			},
		},
		data() {
			return {
				isMoonTomato: false,
				isTomatoSimulator:false,
			}
		},
		methods:{
			toClose(){
				this.$emit('isBaca')
			}
		}
	};
</script>

<style scoped>
	/* 最外层布局 */
	.experiment-page {
		width: 100%;
		height: calc(100vh - 80px); 
		background-color: #fff9e6;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	/* ========== ✅ 头部固定 ========== */
	.header-bar {
		height: 70px;
		flex-shrink: 0;
		background-color: #c5e1a5;
		color: #8b5a2b;
		font-size: 26px;
		font-weight: bold;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 10px;
	}

	.title-icon {
		font-size: 28px;
	}

	.title-text {
		font-size: 26px;
		font-weight: bold;
	}

	/* ========== ✅ 内容区域独立滚动 ========== */
	.scroll-content {
		height:90%;
		flex: 1;
		overflow-y: auto;
		padding-bottom: 20px;
	}

	/* 称号进度卡片 */
	.rank-card {
		margin: 16px;
		padding: 20px;
		background-color: #fff;
		border: 2px solid #4CAF50;
		border-radius: 16px;
		display: flex;
		align-items: center;
		gap: 16px;
	}

	.rank-icon {
		font-size: 48px;
	}

	.rank-title {
		font-size: 22px;
		color: #2196F3;
		margin: 0 0 8px;
	}

	.rank-desc {
		font-size: 16px;
		color: #666;
		margin: 0;
	}

	/* 实验数据统计 */
	.stats-row {
		display: flex;
		margin: 0 16px 20px;
		gap: 16px;
	}

	.stat-item {
		flex: 1;
		background-color: #fff;
		border-radius: 16px;
		padding: 20px 0;
		text-align: center;
	}

	.stat-num {
		font-size: 32px;
		font-weight: bold;
		color: #4CAF50;
	}

	.stat-label {
		font-size: 16px;
		color: #666;
		margin-top: 8px;
	}

	/* 模式标题 */
	.mode-title {
		font-size: 20px;
		color: #333;
		margin: 0 16px 16px;
	}

	/* 实验模式卡片 */
	.mode-card {
		margin: 0 16px 16px;
		padding: 20px;
		background-color: #fff;
		border-radius: 16px;
	}

	.mode-header {
		display: flex;
		align-items: center;
		gap: 12px;
		margin-bottom: 12px;
	}

	.mode-icon {
		font-size: 40px;
	}

	.mode-name {
		font-size: 24px;
		color: #333;
		margin: 0;
	}

	.mode-desc {
		font-size: 16px;
		color: #666;
		line-height: 1.6;
		margin: 0 0 16px;
	}

	.tag-group {
		display: flex;
		gap: 12px;
	}

	.tag-item {
		background-color: #e8f5e9;
		color: #2E7D32;
		padding: 8px 16px;
		border-radius: 20px;
		font-size: 16px;
	}

	/* 探索提示卡片 */
	.tip-card {
		margin: 0 16px 16px;
		padding: 20px;
		background-color: #fffde7;
		border-radius: 16px;
	}

	.tip-header {
		display: flex;
		align-items: center;
		gap: 12px;
		margin-bottom: 12px;
	}

	.tip-icon {
		font-size: 24px;
	}

	.tip-title {
		font-size: 20px;
		color: #333;
		margin: 0;
	}

	.tip-list {
		margin: 0;
		padding-left: 20px;
	}

	.tip-list li {
		font-size: 16px;
		color: #666;
		margin-bottom: 8px;
		line-height: 1.6;
	}
</style>